const translationEn = {
  message: {
    button: {
      add: 'Add',
      close: 'Close',
      add_foobar: 'Add Foobar',
      add_snippet: 'Add Snippet',
      edit_snippet_order: 'Edit Snippet Order',
      save: 'Save',
      delete: 'Delete'
    },
    error: {
      saving_foobar_failed: 'Could not save Foobar!',
      deleting_foobar_failed: 'Deleting Foobar Snippet Failed!'
    },
    field: {
      dependency: 'Dependency',
      description: 'Description',
      output: 'Output',
      snippets: 'Snippets',
      md: 'Markdown',
      title: 'Title'
    },
    form: {
      placeholder: {
        description: 'Enter Foobar description ...',
        lang: 'Select Foobar Snippet language',
        output: 'Enter Snippet Output ...',
        query: 'Enter your Foobar search query:',
        md: 'Enter Foobar data in Markdown ...'
      }
    },
    icon: {
      title: {
        edit: 'Edit Foobar',
        delete: 'Delete Foobar',
        hide: 'Hide Foobar',
        news_status_NEWS: 'Remove News status',
        news_status_AVAILABLE: 'Add News status',
        show: 'Show Foobar'
      }
    },
    title: {
      menu: 'Menu',
      tags: 'Tags',
      main: {
        add: 'Add',
        add_foobar: 'Add Foobar',
        contacts: 'Contacts',
        foobar_beer: 'Foobar Beer',
        foobar_editor: 'Foobar Editor',
        foobars: 'Foobars',
        home: 'Home',
        social: 'Social',
        news: 'News',
        search: 'Search',
        about_foobar: 'About FooBar.Beer',
        privacy_and_license: 'Privacy Policy & License'
      }
    },
    text: {
      deleted: 'Deleted',
      displaying_search_results: 'Displaying {count} results for query:<br><br>&nbsp;&nbsp;&nbsp;&gt;&nbsp;{query}',
      no_foobars: 'No foobars where found to be displayed in this section.',
      no_search_results: 'Enter something interesting into the query to see the results ;-)',
      no_snippets_found: 'No snippets were added yet ... Try adding some ;-)',
      loading: 'Loading ...',
      saved: 'Foobar saved'
    }
  }
}

const translationCs = {
  message: {
  }
}

export default {
  cs: translationCs,
  en: translationEn
}



// WEBPACK FOOTER //
// ./src/services/i18n.js